<template>
  <div class="a-gallery-map">
    <ImageServiceViewer
      v-if="galleryMapData?.src"
      :src="galleryMapData?.src"
      :region="galleryMapData?.region"
      :modifiers="['light']"
    />
  </div>
</template>

<script>
import galleryMapsData from "@/data/gallery_maps_data.json";
import { ImageServiceViewer } from "@thegetty-private/image-viewer";
import "@thegetty-private/image-viewer/dist/style.css";

const lobbyGalleries = {
  "place/1e868e7f-b751-4912-8e58-c0962983d41f": "CENTER AUDITORIUM",
  "place/6c56553b-3481-406b-90a0-3576a46c7172": "EXHIBITIONS LOBBY",
  "place/fe703baa-5272-48b6-b3ab-8a2881125a77": "VILLA AUDITORIUM"
};

export default {
  name: "GalleryMap",
  components: { ImageServiceViewer },
  props: {
    /**
     * The gallery object from the store
     */
    gallery: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      /**
       * The data source for the gallery names, image src & region / bounding box coordinates
       */
      mapData: galleryMapsData
    };
  },
  computed: {
    /**
     * The name of the gallery map to use/display
     */
    galleryMapName() {
      let mapName;
      if (this.gallery.room) {
        // additional check since there are 3 different "LOBBY"s
        mapName =
          this.gallery.room == "LOBBY" && this.gallery.id in lobbyGalleries
            ? lobbyGalleries[this.gallery.id]
            : this.gallery.room;
      }

      return mapName;
    },
    /**
     * The gallery map data (src & region) to use for display
     */
    galleryMapData() {
      if (this.galleryMapName) {
        let galleryMapObject = this.mapData.find(
          (gallery) => gallery.name == this.galleryMapName
        );

        return galleryMapObject;
      }
      return undefined;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
